export const dateNow = () => {
    let now = new Date();
    let isoFormattedDate = now.toISOString()
    return isoFormattedDate;
}